<template>
  <div class="pui-wrapper page-404">
    <div class="content">
      <img :src="imgLogoConnexion" />
      <div class="e404 message">
        <p class="uppercase">
          {{ $t('platform.404.title') }}
        </p>
        <p>{{ $t('platform.404.subtitle') }}</p>
        <router-link :to="{ name: 'applications' }">
          <pui-button variant="primary">
            {{ $t('platform.404.go_home') }}
          </pui-button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import imgLogoConnexion from '../../static/img/piivo-logo-connexion.svg';

export default {
  components: {},
  data() {
    return {
      imgLogoConnexion,
    };
  },
};
</script>
